"use client"

import { useState } from "react"
import SelectWebAppModal from "../components/SelectWebAppModal"

const Home = () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <div className="min-h-screen flex flex-col">
      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="max-w-4xl w-full p-8 relative">
          <div className="text-center mb-12 bg-white/95 backdrop-blur-sm rounded-xl p-8 shadow-lg">
            <h1 className="text-4xl md:text-5xl font-bold text-black mb-4 tracking-tight">
              AI Testing{" "}
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-pink-600">
                Platform
              </span>
            </h1>
            <p className="text-gray-700 text-lg max-w-2xl mx-auto">
              Experiment with advanced AI models and capabilities to enhance your business strategy
            </p>
          </div>

          <div className="flex justify-center mb-12">
            <button
              onClick={() => setShowModal(true)}
              className="group relative px-8 py-4 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full text-white font-medium text-lg hover:shadow-lg hover:shadow-purple-500/25 transition-all duration-300 overflow-hidden"
            >
              <span className="relative z-10">Select a Copilot</span>
              <span className="absolute inset-0 bg-gradient-to-r from-pink-600 to-purple-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
            </button>
          </div>
        </div>
      </div>

      {/* Footer - Sticky to bottom */}
      <footer className="bg-white/95 backdrop-blur-sm border-t border-gray-300 shadow-sm mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="text-center">
            <p className="text-gray-600 text-sm">© 2025 AI Testing Platform. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {showModal && <SelectWebAppModal onClose={() => setShowModal(false)} />}
    </div>
  )
}

export default Home
